import React from "react";
import { Icon } from "@culturehq/components";

import { PhotoCheers, RecognitionCheers, UserActivityCheers } from "components/common/Cheers";

const Cheers = ({ item }) => {
  switch (item.activityType) {
    case "photo_created":
      return <PhotoCheers photo={item.entity} />;
    case "recognition_created":
      return <RecognitionCheers recognition={item.entity} />;
    default:
      return <UserActivityCheers userActivity={item} />;
  }
};

const CommentCount = ({ item }) => {
  let count = item.commentCount;

  if (["recognition_created", "photo_created", "event_created"].includes(item.activityType)) {
    count = item.entity.commentCount;
  }

  return count > 0 ? `Comments (${count})` : "Comment";
};

const Footer = ({ item, noComments, onCommentsClick }) => (
  <div className="FeedItem__footer clearfix">
    <div className="col-xs-8">
      <Cheers item={item} />
    </div>
    <div className="col-xs-4">
      {!noComments && (
        <button type="button" className="btn FeedItem__footer__comment-button clickable" onClick={onCommentsClick}>
          <Icon icon="ios-chatbubble-outline" />{" "}
          <CommentCount item={item} />
        </button>
      )}
    </div>
  </div>
);

export default Footer;
